import firebase from "../Config/firebase";
import {getAPIPath} from "./HelpingFunction";
import {enable} from "workbox-navigation-preload";

try {
    if ('Notification' in window) {
        const messaging = firebase.messaging();
        messaging()
            .hasPermission()
            .then(enabled => {
                if (enabled) {
                    firebase.analytics().logEvent('messaging_permission_accepted');
                    messaging.getToken({vapidKey: "BE7FT7GwqwzVasd6Htn8qLEWHaAR3hi-cdHGe7vBR_sj8khdWeUIbwqdii_rVQR0JVFX5l4i2p6mAFkrNaGP1V8"}).then((currentToken) => {
                        if (currentToken) {

                            if (localStorage.getItem('mewesearcher-gcm-id') !== currentToken) {
                                localStorage.setItem('mewesearcher-gcm-id', currentToken);
                                return new Promise(async (resolve, reject) => {
                                    await fetch(getAPIPath("/api/gcm/addID"), {
                                        method: 'POST',
                                        headers: {"Content-Type": "application/json"},
                                        body: JSON.stringify({
                                            id: currentToken,
                                        })
                                    })
                                        .then((res) => res.json()).then((response) => {
                                            if (response.success) {

                                            }

                                        })
                                })
                            }

                        } else {
                            // Show permission request.
                            console.log('No registration token available. Request permission to generate one.');
                            // Show permission UI.

                        }
                    }).catch((err) => {
                        console.log('An error occurred while retrieving token. ', err);

                    });

                } else {
                    firebase.analytics().logEvent('messaging_permission_rejected');
                }
            })


        messaging.onMessage((payload) => {
            console.log('Message received. ', payload);
        });
    }
} catch (e) {
    console.log(e)
}


try {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
            .then(function (registration) {
                console.log("Registration successful, scope is:", registration.scope);
            })
            .catch(function (err) {
                console.log("Service worker registration failed, error:", err);
            });
    }
} catch (e) {
    console.log(e)
}
